export enum PolicyActions {
  GETDOCUMENTS = 'GETDOCUMENTS',
  GETINSURANCECARD = 'GETINSURANCECARD',
  FILECLAIM = 'FILECLAIM',
  ADDREPLACEVEHICLE = 'ADDREPLACEVEHICLE',
  ADDREPLACEDRIVER = 'ADDREPLACEDRIVER',
  EDITCOVERAGEAMOUNTS = 'EDITCOVERAGEAMOUNTS',
  REQUESTAPOLICYUPDATE = 'REQUESTAPOLICYUPDATE',
  EDITLENDERINFO = 'EDITLENDERINFO'
}
